<template>

  <div id="app_form_contact" >

    <div id="contact_us">


      <div class="section-sub form-contact" :style="'background-image: url('+url('/media/image-page/immagine-contatti.jpg')+');'">

          <div class="content">

            <div class="form">
              <div>
                <div class="header">
                  <h1>Contatti</h1>
                </div>

                <div class="line">
                  <div class="field nominative_user full">
                    <div class="in-puddle only-line">
                      <input name="nominative_user" type="text" value="" v-model="field.nominative_user" required>
                      <label class="ttl">{{trans.get('generals.form.complete_name')}}</label>
                    </div>

                    <div v-if="errorMessage.nominative_user" class="field-error">
                      <span>{{errorMessage.nominative_user}}</span>
                    </div>
                    <!-- <span class="error" v-if="errors.nominative_user">L'nominative_user è obbligatorio</span> -->
                  </div>
                  <div class="field phone">
                    <div class="in-puddle only-line">
                      <input name="phone" value="" type="text" v-model="field.phone" required>
                      <label class="ttl">{{trans.get('generals.form.phone')}}</label>
                    </div>

                    <div v-if="errorMessage.phone" class="field-error">
                      <span >{{errorMessage.phone}}</span>
                    </div>

                  </div>


                </div>

                <div class="line">
                  <div class="field email">
                    <div class="in-puddle only-line">
                      <input name="email" value="" type="text" v-model="field.email" required>
                      <label class="ttl">{{trans.get('generals.form.email')}}</label>
                    </div>

                    <div v-if="errorMessage.email" class="field-error">
                      <span >{{errorMessage.email}}</span>
                    </div>

                  </div>

                  <div class="field object_message full">
                    <div class="in-puddle only-line">
                      <input name="object_message" value="" type="text" v-model="field.object_message" required>
                      <label class="ttl">{{trans.get('generals.form.object_message')}}</label>
                    </div>

                    <div v-if="errorMessage.object_message" class="field-error">
                      <span >{{errorMessage.object_message}}</span>
                    </div>

                  </div>
                </div>




                <div class="field">
                  <div class="in-puddle textarea">
                    <textarea type="text" name="message" value="" required="required" v-model="field.message"></textarea>
                    <label class="ttl" for="name">{{trans.get('generals.form.message')}}:</label>
                  </div>
                  <div v-if="errorMessage.message" class="field-error">
                    <span>{{errorMessage.message}}</span>
                  </div>
                </div>


                <div class="field  full">
                  <input type="checkbox" name="accepet_terms" v-model="field.accept_terms">
                  <span class="privacy" v-html="trans.get('generals.privacy')"></span>
                  <div v-if="errorMessage.accept_terms" class="field-error">
                    <span >{{errorMessage.accept_terms}}</span>
                  </div>
                </div>

                <div class="submit login">
                  <button @click="preventSubmit()" class="btn-circle btn-submit" :class="{loading: loading}">{{trans.get('generals.submit')}}</button>
                </div>

              </div>
            </div>
            <!-- form -->
            <footer-info/>
          </div>

      </div>


    </div>
    <!-- #contact_us -->

  </div>


</template>

<script>
export default{

  data: function(){
    return {
      field: {
        nominative_user: '',
        phone : '',
        email : '',
        object_message: '',
        message: '',
     },
     message_error: {
       nominative_user: [this.trans.get('validation.form.complete_name.required'), this.trans.get('validation.form.complete_name.value')],
       phone : [this.trans.get('validation.form.phone.required'), this.trans.get('validation.form.phone.value')],
       email : [this.trans.get('validation.form.email.required'), this.trans.get('validation.form.email.value')],
       object_message: [this.trans.get('validation.form.object.required')],
       message: [this.trans.get('validation.form.message.required')],
       accept_terms : [this.trans.get('validation.form.terms.required')],
       isValid: [this.trans.get('validation.form.is_valid.value')],
     },
      firstSubmit: true,
      loading: false
    }
  },

  computed: {
    validate: function() {
      let fields = {
        nominative_user: this.isDef(this.field.nominative_user) ? (this.is_nominative_user(this.field.nominative_user) ? true : 1) : 0,
        email: this.isDef(this.field.email) ? (this.is_email(this.field.email) ? true : 1) : 0,
        phone: this.isDef(this.field.phone) ? ( this.is_tel(this.field.phone) ? true : 1) : 0,
        object_message: this.isDef(this.field.object_message.trim()) ? true : 0,
        message: this.isDef(this.field.message.trim()) ? true : 0,
        accept_terms: this.field.accept_terms ? true : 0,
      };
      let isValid = true;
      for (let i in fields) {
        if (!(fields[i] === true)) {isValid = false; break; }
      }
      fields['isValid'] = isValid;
      return fields;
    },

    errorMessage: function() {
      let messages = {};
      for (let key in this.validate) {
        if (this.validate[key] === true || !(this.validate[key] === true) && this.firstSubmit) {
          messages[key] = null;
        }
        else {
          messages[key] = this.message_error[key][this.validate[key]]; // specificare il tipo se necessario
        }
      }
      return messages;
    }

  },

  methods: {
    isDef: function(v) {
      return v !== '';
    },

    is_nominative_user: function (pattern){
      var regex = /^[a-záàéèóòúùíì]{1,}([a-záàéèóòúùíì]{1,}[ ']*){1,}[a-záàéèóòúùíì]{1,}$/i;
      return regex.test(pattern.trim());
    },

    is_email: function (pattern) {
      var regex = /^[a-z0-9._-]{3,}@[a-z0-9-]{1,}\.[a-z]{2,10}$/i;
      return regex.test(pattern.trim());
    },

    is_tel: function (pattern){
      var regex = /^(\+[0-9]{2,4}[ ]*)?[0-9]{10,15}$/ig;
      return regex.test(pattern.trim());
    },

    preventSubmit: function() {

      this.firstSubmit = false;

      if (!this.validate.isValid) {
        // app messages for ...

        return;
      }
      this.firstSubmit = false;

      let vue = this;

      vue.loading = true;

      axios({
        method: 'post',
        url: '/richiesta-contatto-cliente',
        data:  vue.field
      })
      .then(res => {

        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        })

        vue.resetForm()

      })
      .catch(err => {

        vue.loading = false;

        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message
        })

      })
      .then(() =>{

        vue.loading = false;

      })

    },

    resetForm: function() {
      for (let i in this.field) {
        this.field[i] = typeof this.field[i] == 'string' ? '' : false;
      }
      this.firstSubmit = true;
    }

  }

}
</script>

<style lang="scss" scoped>


.section-sub.form-contact {
	width: 100%;
	min-height: 100vh;
	color: white;
	background-repeat: no-repeat;
	background-origin: initial;
	background-clip: initial;
	background-size: cover;
	background-position: center;
}
.section-sub.form-contact .content{
  position: relative;
  margin: auto;
}
.form-group {
  padding: 0;
}
@media screen and (max-width: 800px) {
  .section-sub.form-contact .content{
    padding: 0 0.8em;
  }
}
.form {
  color: white;
}
.form .header h1 {
  font-weight: 500;
  margin-top: 0;
}
.form .field {
  margin: 50px 0;
}

.btn-submit {
  font-size: 16px;
}

/*----------------
  CSS IN-PUDLLE
----------------*/
.in-puddle {
  position: relative;
  width: 100%;
  height: 30px;
  line-height: 30px;
  margin: 0em 0;
}
.in-puddle.textarea {
  position: relative;
  width: 100%;
  height: 100px;
  resize: none;
  line-height: 50px;
  margin: 0em 0;
}
.in-puddle label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  color: #f5f5f5;
  transition: 0.2s all;
  cursor: text;
  z-index: 0;
  padding-left: 0px;
  font-weight: 400;
}
.in-puddle.textarea label  {
  padding-left: 16px;
}
.in-puddle input,
.in-puddle textarea {
  width: 100%;
  height: 100%;
  outline: 0;
  padding: 0.5rem 0;
  border: 1px solid white;
  box-shadow: none;
  border-radius: 0px;
  color: white;
  background: transparent;
  position: relative;
  z-index: 1;
  padding-left: 5px;
  font-weight: 300;
  font-size: 1.1em;
}
.in-puddle textarea {
  resize: none;
}
.form .line {
  display: flex;
  justify-content: space-between;
  margin: 50px 0;
}
.form .line .field {
  width: 49%;
  margin: 0;
}
.in-puddle.only-line input {
  border-top: none;
  border-left: none;
  border-right: none;
}

.in-puddle input:focus,
.in-puddle input:valid,
.in-puddle textarea:focus,
.in-puddle textarea:valid {
  border-color: white;
  color: white;
}
.in-puddle input:focus~label,
.in-puddle input:valid~label {
  font-size: 14px;
  top: -28px;
  color: #f5f5f5;
  padding-left: 0;
}
.in-puddle textarea:focus~label,
.in-puddle textarea:valid~label {
  font-size: 14px;
  top: -36px;
  color: #f5f5f5;
  padding-left: 0;
}
/* ------ Info Error ------ */
.field-error {
    color: white;
    display: flex;
    font-size: 12px;
    line-height: normal;
    margin-top: 2px;
    position: relative;
    padding-left:  0px;
    opacity: 0;
    padding-top: 5px;
    overflow-y: visible;
    height: 0px;
    animation: moveError 0.2s ease-in forwards;
}
@keyframes moveError {
  100% {
    padding-left:  25px;
    opacity: 1;
  }
}
.field-error::before {
  display: flex;
  align-items: center;
  justify-content: center;
  content: "\0021"; /* ! */
  color: white;
  width: 16px;
  height: 16px;
  top: 5px;
  left: 0;
  position: absolute;
  border-radius: 100%;
  background-color: var(--red) ;
}

/*
* Animazione bottone
*/
.btn-submit.loading{
  color: transparent !important;
}
.btn-submit.loading:before{
  content: '';
  position: absolute;
  z-index: 3;
  top: 50% !important;
  left: 50% !important;
  width: 20px !important;
  height: 20px !important;
  border: 2px solid white !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  border-radius: 50% !important;
  animation: spin-loader .4s linear infinite;
  background-color: transparent !important;
  filter: none !important;
}

/* The animation code */
/* @keyframes moveError {
  from {background-color: red;}
  to {background-color: yellow;}
} */


</style>
